import { dragDirective } from '@vueuse/gesture';

export default defineNuxtPlugin(nuxtApp => {
	if (import.meta.client) {
		nuxtApp.vueApp.directive('drag', dragDirective);
	}
	// Isso serve para previnir que essa diretiva seja configurada no servidor com as funcionalidades que são 100% client. Outra alternativa pra isso é definir o plugin como client-only.
	if (import.meta.server) {
		nuxtApp.vueApp.directive('drag', () => {});
	}
});
